import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { LEGAL_DOCS } from "@/legal/content";
import { ArrowUpRight, Map } from "lucide-react";

const SECTIONS = [
  {
    label: "Main",
    links: [
      ["Home", "/"],
      ["How it works", "/#how"],
      ["Pricing", "/pricing"],
      ["Request a Demo", "/demo"],
      ["Verify a passport", "/verify"],
      ["Trust & Safety", "/trust-safety"],
    ],
  },
  {
    label: "For You",
    links: [
      ["For Students", "/for-students"],
      ["For Employers", "/employers"],
      ["For Institutions", "/institutions"],
      ["Get Recognized", "/get-recognized"],
    ],
  },
  {
    label: "Account",
    links: [
      ["Register", "/register"],
      ["Sign in", "/login"],
    ],
  },
];

const LEGAL_SLUGS = [
  "terms-of-service",
  "privacy-policy",
  "cookie-policy",
  "subscription-refund-policy",
];

export default function Sitemap() {
  return (
    <div className="bg-ec-bg text-ec-ink min-h-screen" data-testid="sitemap-page">
      <Navbar />
      <section className="max-w-5xl mx-auto px-6 sm:px-10 py-20">
        <div className="inline-flex items-center gap-2 border border-ec-line bg-white px-3 py-1 text-xs eyebrow">
          <Map className="w-3.5 h-3.5 text-ec-emerald" />
          Sitemap
        </div>
        <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tighter leading-[0.95] mt-6">
          Every public page in <span className="text-ec-emerald">one place.</span>
        </h1>
        <p className="text-lg text-ec-ink-soft mt-5 max-w-2xl">
          A directory of every EthicCred marketing, product, and legal page — for humans and search
          engines. For machine readers, see{" "}
          <a href="/sitemap.xml" className="underline font-semibold">sitemap.xml</a>.
        </p>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {SECTIONS.map((sec) => (
            <div key={sec.label}>
              <div className="eyebrow mb-4">{sec.label}</div>
              <ul className="space-y-2.5">
                {sec.links.map(([label, href]) => (
                  <li key={label}>
                    {href.startsWith("/#") ? (
                      <a href={href} className="text-sm hover:text-ec-emerald inline-flex items-center gap-1">
                        {label} <ArrowUpRight className="w-3 h-3" />
                      </a>
                    ) : (
                      <Link to={href} className="text-sm hover:text-ec-emerald inline-flex items-center gap-1" data-testid={`sitemap-link-${href.replace(/\//g, "-")}`}>
                        {label} <ArrowUpRight className="w-3 h-3" />
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <div className="eyebrow mb-4">Legal</div>
            <ul className="space-y-2.5">
              {LEGAL_SLUGS.map((slug) => (
                <li key={slug}>
                  <Link
                    to={`/legal/${slug}`}
                    className="text-sm hover:text-ec-emerald inline-flex items-center gap-1"
                    data-testid={`sitemap-legal-${slug}`}
                  >
                    {LEGAL_DOCS[slug]?.title || slug} <ArrowUpRight className="w-3 h-3" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
